import VBottomNav from './VBottomNav';
export { VBottomNav };
export default VBottomNav;
//# sourceMappingURL=index.js.map